import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { CurrentService } from '../../../services/current.service';
import { DatasService } from '../../../services/datas.service';
import { GTM } from 'src/app/services/gtm.service';
import { Router } from '@angular/router';
import { getHbmTotalSteps } from 'src/app/services/helpers/app-context-helper';
import { CustomerService } from 'src/app/services/customer.service';

@Component({
  selector: 'ng-casto-kitchen-fridge',
  templateUrl: './fridge.component.html',
})
export class KitchenFridgeComponent implements OnInit {
  @Output() onComplete: EventEmitter<void> = new EventEmitter();

  constructor(
    public current: CurrentService,
    public datas: DatasService,
    public gtm: GTM,
    private readonly router: Router,
    private readonly customer: CustomerService
  ) {}

  ngOnInit(): void {
    this.gtm.trackPage(`${this.router.url}/choix/refrigerateur`, 'Cuisine | Choix', {
      stepNumber: 5,
      totalSteps: getHbmTotalSteps(this.customer.context),
    });
  }

  selectFridgeConfiguration(fridgeConfigurationRef: string) {
    this.current.kitchen.fridgeConfigurationRef = fridgeConfigurationRef;
    this.onComplete.emit();
  }
}
